import React from "react";
import { useI18n } from "@/i18n/I18nContext";

const SITE = "GoalGrid";
const CONTACT = "contact@goalgrid.example";

export default function Privacy() {
  const { t } = useI18n();
  return (
    <div data-testid="privacy-page" className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="border-b border-white/10 pb-6">
        <h1 className="font-display text-5xl sm:text-6xl uppercase tracking-tighter">
          {t("privacy.title")}
        </h1>
        <p className="text-xs uppercase tracking-[0.22em] text-white/40 mt-2">
          {t("privacy.last_updated")}: {new Date().toLocaleDateString()}
        </p>
      </div>

      <div className="prose prose-invert max-w-none mt-8 space-y-8 text-white/80 leading-relaxed">
        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white">
            1. {t("privacy.s1.title")}
          </h2>
          <p className="mt-2">{t("privacy.s1.body", { site: SITE })}</p>
        </section>

        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white">
            2. {t("privacy.s2.title")}
          </h2>
          <p className="mt-2">{t("privacy.s2.body")}</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>{t("privacy.s2.item1")}</li>
            <li>{t("privacy.s2.item2")}</li>
            <li>{t("privacy.s2.item3")}</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white">
            3. {t("privacy.s3.title")}
          </h2>
          <p className="mt-2">{t("privacy.s3.body")}</p>
          <p className="mt-2">
            <a
              href="https://policies.google.com/technologies/ads"
              target="_blank"
              rel="noopener noreferrer"
              className="text-volt underline hover:no-underline"
            >
              policies.google.com/technologies/ads
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white">
            4. {t("privacy.s4.title")}
          </h2>
          <p className="mt-2">{t("privacy.s4.body")}</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Google AdSense (advertising)</li>
            <li>ESPN public API (live football data)</li>
            <li>Anthropic Claude (AI match analysis)</li>
            <li>PostHog (anonymous analytics)</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white">
            5. {t("privacy.s5.title")}
          </h2>
          <p className="mt-2">{t("privacy.s5.body")}</p>
        </section>

        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white">
            6. {t("privacy.s6.title")}
          </h2>
          <p className="mt-2">
            {t("privacy.s6.body")}{" "}
            <a href={`mailto:${CONTACT}`} className="text-volt underline hover:no-underline">
              {CONTACT}
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
